import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { QueryConfig } from '@/lib/react-query';
import type { Tournament } from '@/types/api';

export class PlanRequiredError extends Error {
  constructor() {
    super('The scoreboard is not included in this tournament plan');
    this.name = 'PlanRequiredError';
  }
}

export const getTournament = (): Promise<{ tournament: Tournament }> => {
  return api.get(`/scoreboard/v1/tournament`, { silent: true });
};

export const getTournamentQueryOptions = () => {
  return queryOptions({
    queryKey: ['tournament'],
    queryFn: () => getTournament(),
  });
};

type UseTournamentQueryOptions = {
  queryConfig?: QueryConfig<typeof getTournamentQueryOptions>;
};

export const useTournament = ({
  queryConfig,
}: UseTournamentQueryOptions = {}) => {
  return useQuery({
    ...getTournamentQueryOptions(),
    ...queryConfig,
  });
};
